// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
    font-family: 'Uniform', sans-serif;
    font-style: normal;
	font-size: 14px;
    }
:root {
	--primary: #238ebc;
	--neutral: rgba(128, 128, 128, 0.699);
	--secondary: #a1cc9c;
	--text-primary: navy;
}

body {
	margin: 0;
	font-family:
		'Uniform',
		'Open Sans',
		'sans-serif',
		-apple-system,
		BlinkMacSystemFont,
		'Segoe UI',
		'Roboto',
		'Oxygen',
		'Ubuntu',
		'Cantarell',
		'Fira Sans',
		'Droid Sans',
		'Helvetica Neue',
		sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	background: var(--secondary);
}

code {
	font-family: Uniform, source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}
* {
	color: var(--text-primary);
	margin: 0;
}
p {
	margin: 10px 0;
}
button {
	border: 0;
	padding: 8px;
	border-radius: 10px;
	color: white;
	background: var(--primary);
	cursor: pointer;
	font-weight: 400;
}

/* navbar */
/*header nav {
	display: flex;
	gap: 10px;
	justify-content: flex-end;
	max-width: 1200px;
	margin: 0 auto;
}
header nav h1 {
	margin-right: 220px;
	border-bottom: 3px solid var(--primary);
}
header nav a {
	text-decoration: none;
	padding: 6px;
	border-radius: 4px;
}
header nav a.active {
	background: var(--primary);
}

main {
	max-width: 1200px;
	margin: 40px auto;
}*/
/* contact form */
/*form {
	margin-top: 10px;
	border-radius: 15px 50px 30px 5px;
}*/
form input,
form label span,
form textarea {
	display: block;
}
form input {
	height: auto;
	margin: 10px;
	padding: auto;
}
form textarea{
	margin: 10px;
}
form select {
	margin: 5px;
	margin-left: 10px;
	padding: auto;
	/* width: 300px;*/
	color: var(--secondary);
}
form label span {
	margin: 5px;
}
/* full screen for map*/
.full-screen {
	width: 100%;
	height: 100%;
}
/*avtar logo*/
/*.menu-container {
	position: relative;
}
.menu-header {
	display: flex;
	align-items: center;
}
.menu-logo {
	height: 40px;
	gap: 10px;
}
.menu-toggle {
	position: absolute;
	top: 10px;
	right: 10px;
	font-size: 30px;
	background: none;
	border: none;
}*/
/*login page*/
.login-page {
	max-width: 400px;
	margin: 0 auto;
	padding: 20px;
}

.logo {
	display: flex;
	margin: 0 auto;
	margin-top: 50px;
	width: 100px;
	height: 100px;
	padding-bottom: 5px;
}

.login-page h1 {
	text-align: center;
	padding-bottom: 5px;
}

.login-page form {
	display: flex;
	flex-direction: column;
}
.login-page form select {
	display: block;
	padding-bottom: 5px;
}

.login-page label {
	margin-top: 10px;
	padding-bottom: 5px;
}

.login-page input {
	padding: 10px;
	margin-top: 5px;
	text-transform: none;
}

.login-page button {
	margin-top: 10px;
	padding: 10px;
}

.error {
	color: red;
	margin-top: 10px;
}
/*Registration form*/
.registration-page {
	max-width: 400px;
	margin: 0 auto;
	padding: 8px;
}

.registration-page h1 {
	text-align: center;
}

.registration-page form {
	display: flex;
	flex-direction: column;
}

.registration-page input,
.registration-page select,
.registration-page textarea {
	padding: 10px;
	margin-top: 4px;
}

.registration-page button {
	margin-top: 4px;
	padding: 4px;
}

.gender {
	display: flex;
	align-items: center;
	margin-left: 10px;
}

.gender span {
	margin-right: 10px;
}

.gender label {
	display: flex;
	align-items: center;
	margin-right: 40px;
	
}
.gender label input {
	display: flex;
	align-items: center;
	margin-top: 10px;
}
/* breadcrumbs */
.breadcrumbs {
	max-width: 1200px;
	margin: 20px auto;
}
.breadcrumbs > * {
	display: inline-block;
	margin-right: 10px;
}
.breadcrumbs .crumb:after {
	content: '>';
	margin-left: 10px;
}
.breadcrumbs .crumb:last-child:after {
	display: none;
}
.breadcrumbs .crumb a {
	color: #ddd;
}
@media print {
    .no-print {
      display: none !important;
    }
	.printable-paper {
		width: 100%;
		transform: scale(0.75); /* Adjust this value as needed */
		transform-origin: top left;
	  }
	
	  table {
		font-size: 1.5em; /* Adjust font size if needed */
	  }
	
	  th, td {
		padding: 5px;
	  }
  }
@media (max-width: 600px) {
	.menu {
		display: none;
		flex-direction: column;
		position: absolute;
		top: 60px;
		right: 0;
		background: white;
		border: 1px solid #ccc;
		box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
	}

	.menu.open {
		display: flex;
	}

	.menu li {
		margin-right: 0;
		padding: 10px;
	}
}
.assign-info {
	display: flex;
	width: 100%;
}
.assign-info .map-section {
	width: 80%;
}
.assign-info .form-section {
	width: 20%;
	padding: 20px;
	margin-left: 20px;
	background-color: grey;
}
@media (min-width: 601px) {
	.menu-toggle {
		display: none;
		background-color: var(--secondary);
	}
	.menu {
		display: flex;
	}
	.menu li {
		font-weight: bolder;
	}
}
`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,kBAAkB;CACrB,eAAe;IACZ;AACJ;CACC,kBAAkB;CAClB,qCAAqC;CACrC,oBAAoB;CACpB,oBAAoB;AACrB;;AAEA;CACC,SAAS;CACT;;;;;;;;;;;;;;YAcW;CACX,mCAAmC;CACnC,kCAAkC;CAClC,4BAA4B;AAC7B;;AAEA;CACC,wFAAwF;AACzF;AACA;CACC,0BAA0B;CAC1B,SAAS;AACV;AACA;CACC,cAAc;AACf;AACA;CACC,SAAS;CACT,YAAY;CACZ,mBAAmB;CACnB,YAAY;CACZ,0BAA0B;CAC1B,eAAe;CACf,gBAAgB;AACjB;;AAEA,WAAW;AACX;;;;;;;;;;;;;;;;;;;;;;;EAuBE;AACF,iBAAiB;AACjB;;;EAGE;AACF;;;CAGC,cAAc;AACf;AACA;CACC,YAAY;CACZ,YAAY;CACZ,aAAa;AACd;AACA;CACC,YAAY;AACb;AACA;CACC,WAAW;CACX,iBAAiB;CACjB,aAAa;CACb,iBAAiB;CACjB,uBAAuB;AACxB;AACA;CACC,WAAW;AACZ;AACA,uBAAuB;AACvB;CACC,WAAW;CACX,YAAY;AACb;AACA,aAAa;AACb;;;;;;;;;;;;;;;;;;EAkBE;AACF,aAAa;AACb;CACC,gBAAgB;CAChB,cAAc;CACd,aAAa;AACd;;AAEA;CACC,aAAa;CACb,cAAc;CACd,gBAAgB;CAChB,YAAY;CACZ,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,sBAAsB;AACvB;AACA;CACC,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,eAAe;CACf,oBAAoB;AACrB;;AAEA;CACC,gBAAgB;CAChB,aAAa;AACd;;AAEA;CACC,UAAU;CACV,gBAAgB;AACjB;AACA,oBAAoB;AACpB;CACC,gBAAgB;CAChB,cAAc;CACd,YAAY;AACb;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,sBAAsB;AACvB;;AAEA;;;CAGC,aAAa;CACb,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,YAAY;AACb;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,kBAAkB;;AAEnB;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,gBAAgB;AACjB;AACA,gBAAgB;AAChB;CACC,iBAAiB;CACjB,iBAAiB;AAClB;AACA;CACC,qBAAqB;CACrB,kBAAkB;AACnB;AACA;CACC,YAAY;CACZ,iBAAiB;AAClB;AACA;CACC,aAAa;AACd;AACA;CACC,WAAW;AACZ;AACA;IACI;MACE,wBAAwB;IAC1B;CACH;EACC,WAAW;EACX,sBAAsB,EAAE,gCAAgC;EACxD,0BAA0B;GACzB;;GAEA;EACD,gBAAgB,EAAE,+BAA+B;GAChD;;GAEA;EACD,YAAY;GACX;EACD;AACF;CACC;EACC,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,sBAAsB;EACtB,0CAA0C;CAC3C;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,eAAe;EACf,aAAa;CACd;AACD;AACA;CACC,aAAa;CACb,WAAW;AACZ;AACA;CACC,UAAU;AACX;AACA;CACC,UAAU;CACV,aAAa;CACb,iBAAiB;CACjB,sBAAsB;AACvB;AACA;CACC;EACC,aAAa;EACb,kCAAkC;CACnC;CACA;EACC,aAAa;CACd;CACA;EACC,mBAAmB;CACpB;AACD","sourcesContent":["*{\r\n    font-family: 'Uniform', sans-serif;\r\n    font-style: normal;\r\n\tfont-size: 14px;\r\n    }\r\n:root {\r\n\t--primary: #238ebc;\r\n\t--neutral: rgba(128, 128, 128, 0.699);\r\n\t--secondary: #a1cc9c;\r\n\t--text-primary: navy;\r\n}\r\n\r\nbody {\r\n\tmargin: 0;\r\n\tfont-family:\r\n\t\t'Uniform',\r\n\t\t'Open Sans',\r\n\t\t'sans-serif',\r\n\t\t-apple-system,\r\n\t\tBlinkMacSystemFont,\r\n\t\t'Segoe UI',\r\n\t\t'Roboto',\r\n\t\t'Oxygen',\r\n\t\t'Ubuntu',\r\n\t\t'Cantarell',\r\n\t\t'Fira Sans',\r\n\t\t'Droid Sans',\r\n\t\t'Helvetica Neue',\r\n\t\tsans-serif;\r\n\t-webkit-font-smoothing: antialiased;\r\n\t-moz-osx-font-smoothing: grayscale;\r\n\tbackground: var(--secondary);\r\n}\r\n\r\ncode {\r\n\tfont-family: Uniform, source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\r\n}\r\n* {\r\n\tcolor: var(--text-primary);\r\n\tmargin: 0;\r\n}\r\np {\r\n\tmargin: 10px 0;\r\n}\r\nbutton {\r\n\tborder: 0;\r\n\tpadding: 8px;\r\n\tborder-radius: 10px;\r\n\tcolor: white;\r\n\tbackground: var(--primary);\r\n\tcursor: pointer;\r\n\tfont-weight: 400;\r\n}\r\n\r\n/* navbar */\r\n/*header nav {\r\n\tdisplay: flex;\r\n\tgap: 10px;\r\n\tjustify-content: flex-end;\r\n\tmax-width: 1200px;\r\n\tmargin: 0 auto;\r\n}\r\nheader nav h1 {\r\n\tmargin-right: 220px;\r\n\tborder-bottom: 3px solid var(--primary);\r\n}\r\nheader nav a {\r\n\ttext-decoration: none;\r\n\tpadding: 6px;\r\n\tborder-radius: 4px;\r\n}\r\nheader nav a.active {\r\n\tbackground: var(--primary);\r\n}\r\n\r\nmain {\r\n\tmax-width: 1200px;\r\n\tmargin: 40px auto;\r\n}*/\r\n/* contact form */\r\n/*form {\r\n\tmargin-top: 10px;\r\n\tborder-radius: 15px 50px 30px 5px;\r\n}*/\r\nform input,\r\nform label span,\r\nform textarea {\r\n\tdisplay: block;\r\n}\r\nform input {\r\n\theight: auto;\r\n\tmargin: 10px;\r\n\tpadding: auto;\r\n}\r\nform textarea{\r\n\tmargin: 10px;\r\n}\r\nform select {\r\n\tmargin: 5px;\r\n\tmargin-left: 10px;\r\n\tpadding: auto;\r\n\t/* width: 300px;*/\r\n\tcolor: var(--secondary);\r\n}\r\nform label span {\r\n\tmargin: 5px;\r\n}\r\n/* full screen for map*/\r\n.full-screen {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n}\r\n/*avtar logo*/\r\n/*.menu-container {\r\n\tposition: relative;\r\n}\r\n.menu-header {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n}\r\n.menu-logo {\r\n\theight: 40px;\r\n\tgap: 10px;\r\n}\r\n.menu-toggle {\r\n\tposition: absolute;\r\n\ttop: 10px;\r\n\tright: 10px;\r\n\tfont-size: 30px;\r\n\tbackground: none;\r\n\tborder: none;\r\n}*/\r\n/*login page*/\r\n.login-page {\r\n\tmax-width: 400px;\r\n\tmargin: 0 auto;\r\n\tpadding: 20px;\r\n}\r\n\r\n.logo {\r\n\tdisplay: flex;\r\n\tmargin: 0 auto;\r\n\tmargin-top: 50px;\r\n\twidth: 100px;\r\n\theight: 100px;\r\n\tpadding-bottom: 5px;\r\n}\r\n\r\n.login-page h1 {\r\n\ttext-align: center;\r\n\tpadding-bottom: 5px;\r\n}\r\n\r\n.login-page form {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n}\r\n.login-page form select {\r\n\tdisplay: block;\r\n\tpadding-bottom: 5px;\r\n}\r\n\r\n.login-page label {\r\n\tmargin-top: 10px;\r\n\tpadding-bottom: 5px;\r\n}\r\n\r\n.login-page input {\r\n\tpadding: 10px;\r\n\tmargin-top: 5px;\r\n\ttext-transform: none;\r\n}\r\n\r\n.login-page button {\r\n\tmargin-top: 10px;\r\n\tpadding: 10px;\r\n}\r\n\r\n.error {\r\n\tcolor: red;\r\n\tmargin-top: 10px;\r\n}\r\n/*Registration form*/\r\n.registration-page {\r\n\tmax-width: 400px;\r\n\tmargin: 0 auto;\r\n\tpadding: 8px;\r\n}\r\n\r\n.registration-page h1 {\r\n\ttext-align: center;\r\n}\r\n\r\n.registration-page form {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n}\r\n\r\n.registration-page input,\r\n.registration-page select,\r\n.registration-page textarea {\r\n\tpadding: 10px;\r\n\tmargin-top: 4px;\r\n}\r\n\r\n.registration-page button {\r\n\tmargin-top: 4px;\r\n\tpadding: 4px;\r\n}\r\n\r\n.gender {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tmargin-left: 10px;\r\n}\r\n\r\n.gender span {\r\n\tmargin-right: 10px;\r\n}\r\n\r\n.gender label {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tmargin-right: 40px;\r\n\t\r\n}\r\n.gender label input {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tmargin-top: 10px;\r\n}\r\n/* breadcrumbs */\r\n.breadcrumbs {\r\n\tmax-width: 1200px;\r\n\tmargin: 20px auto;\r\n}\r\n.breadcrumbs > * {\r\n\tdisplay: inline-block;\r\n\tmargin-right: 10px;\r\n}\r\n.breadcrumbs .crumb:after {\r\n\tcontent: '>';\r\n\tmargin-left: 10px;\r\n}\r\n.breadcrumbs .crumb:last-child:after {\r\n\tdisplay: none;\r\n}\r\n.breadcrumbs .crumb a {\r\n\tcolor: #ddd;\r\n}\r\n@media print {\r\n    .no-print {\r\n      display: none !important;\r\n    }\r\n\t.printable-paper {\r\n\t\twidth: 100%;\r\n\t\ttransform: scale(0.75); /* Adjust this value as needed */\r\n\t\ttransform-origin: top left;\r\n\t  }\r\n\t\r\n\t  table {\r\n\t\tfont-size: 1.5em; /* Adjust font size if needed */\r\n\t  }\r\n\t\r\n\t  th, td {\r\n\t\tpadding: 5px;\r\n\t  }\r\n  }\r\n@media (max-width: 600px) {\r\n\t.menu {\r\n\t\tdisplay: none;\r\n\t\tflex-direction: column;\r\n\t\tposition: absolute;\r\n\t\ttop: 60px;\r\n\t\tright: 0;\r\n\t\tbackground: white;\r\n\t\tborder: 1px solid #ccc;\r\n\t\tbox-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);\r\n\t}\r\n\r\n\t.menu.open {\r\n\t\tdisplay: flex;\r\n\t}\r\n\r\n\t.menu li {\r\n\t\tmargin-right: 0;\r\n\t\tpadding: 10px;\r\n\t}\r\n}\r\n.assign-info {\r\n\tdisplay: flex;\r\n\twidth: 100%;\r\n}\r\n.assign-info .map-section {\r\n\twidth: 80%;\r\n}\r\n.assign-info .form-section {\r\n\twidth: 20%;\r\n\tpadding: 20px;\r\n\tmargin-left: 20px;\r\n\tbackground-color: grey;\r\n}\r\n@media (min-width: 601px) {\r\n\t.menu-toggle {\r\n\t\tdisplay: none;\r\n\t\tbackground-color: var(--secondary);\r\n\t}\r\n\t.menu {\r\n\t\tdisplay: flex;\r\n\t}\r\n\t.menu li {\r\n\t\tfont-weight: bolder;\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
